<template>
  <section>
<!--    <div class="d-flex flex-row justify-space-between align-center mb-3">-->
<!--      <h1 class="section-header__title">-->
<!--        Справочник организаций-->
<!--      </h1>-->
<!--      <div class="d-flex flex-row align-start">-->
<!--        <v-icon-->
<!--            size="20"-->
<!--            color="info"-->
<!--            class="mt-2 mr-2"-->
<!--        >-->
<!--          mdi-magnify-->
<!--        </v-icon>-->
<!--        <v-text-field-->
<!--            v-model.lazy="search"-->
<!--            color="info"-->
<!--            outlined-->
<!--            label="Начните набирать наименование организации"-->
<!--            class="search-field"-->
<!--            dense-->
<!--            style="min-width: 500px"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
    <wrapper-preview-category>
      <grid-table-full
          :headers="headers.massive"
          :headers-for-rows="headers.massive"
          :num-cols="headers.countCells"
          :loading-data="loading"
          :data-rows="serverData"
          type-table="grid"
          :data-fields-for-search="['id','name']"
          name-table="Справочник организаций"
          label-search="Начните набирать наименование организации"
      >
        <template #region1="{row,cell}">
          <div v-html="cell.template(row)"></div>
          <contact-menu :id="row.id" type-contact="organization" :props-contact="[]">
            <template #header-title>
              {{ row.name }}
            </template>
          </contact-menu>
        </template>
        <template #actions="{row}">
          <v-btn class="white__v-btn" @click="authAdOrg(row)">Войти</v-btn>
        </template>
        <template #blocks="{row}">
<!--          <v-btn-->
<!--              icon-->
<!--              :disabled="blocking.value"-->
<!--              :loading="blocking.value && blocking.id === row.id"-->
<!--          >-->
<!--            <v-icon size="24" :color="'info' ">-->
<!--              mdi-lock-open-outline-->
<!--            </v-icon>-->
<!--          </v-btn>-->
          <block-menu :id="row.id">
            <template #header-title>Блокировка</template>
          </block-menu>
        </template>
      </grid-table-full>
<!--      <div class="mt-3 d-flex flex-row justify-center align-center">-->
<!--        <v-autocomplete-->
<!--            class="pagination-table"-->
<!--            v-model="userPages"-->
<!--            :items="pagesPaginate"-->
<!--            solo-->
<!--            dense-->
<!--            filled-->
<!--            height="25"-->
<!--            rounded-->
<!--            style="max-width: 150px"-->
<!--            @change="changePage($event)"-->
<!--        ></v-autocomplete>-->
<!--        <v-pagination-->
<!--            v-model="page"-->
<!--            :length="pagesVuetify"-->
<!--            :total-visible="7"-->
<!--            @input="changePage($event)"-->
<!--        >-->
<!--        </v-pagination>-->

<!--      </div>-->
    </wrapper-preview-category>

  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
// import GridTable from "@/components/GridTable/GridTable";
import ContactMenu from "@/components/Menus/contact-menu";
import config from "@/pages/Admin/configs/org_config";
import {mapActions, mapGetters} from "vuex";
import {tablePagination} from "@/mixins/tablePagination";
import BlockMenu from "@/components/Menus/block-menu";
import GridTableFull from "@/components/GridTable/GridTableFull";
// import UserController from "@/controllers/UserController";

export default {
  name: "Organizations",
  components: {GridTableFull, BlockMenu, ContactMenu,  WrapperPreviewCategory},
  mixins: [tablePagination],
  data() {
    return {
      // search: '',
      headers: config,
      blocking: {value: false, id: null},
    }
  },
  computed: {
    ...mapGetters('spr', {
      getOrgs: 'getOrgs',
      getOrgsStatus: 'getOrgsStatus'
    }),
    loading() {
      return this.getOrgsStatus
    },
    serverData() {
      return this.getOrgs.filter(el => !!el).sort((a, b) => a.id - b.id)
          // .filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1 || String(el.id).toLowerCase().search(this.search.toLowerCase()) !== -1)
    }
  },
  created() {
    // this.getServerData()
  },
  methods: {
    // ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer', changeBlockInfo: 'changeBlockInfo'}),
    ...mapActions('keycloak', {initFakeUser: 'initFakeUser'}),
    ...mapActions('checkFilled', {
      loadingBlockInfo: 'loadingBlockInfo',
      loadingFiles: 'loadingFiles',
      getContact: 'getContact'
    }),
    ...mapActions('spr', {getOrgByOwner: 'getOrgByOwner'}),
    ...mapActions('appeals', {
      getAllAppealsFormsFive: 'getAllAppealsFormsFive',
      getAllOrganizationAppeals: 'getAllOrganizationAppeals'
    }),
    // checkOnBlock(row){
    //   return row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === 2) &&  row.stageDataBlocks.find(el => el.stageId === 2)?.block === true
    // },
    // async getServerData() {
    //   try {
    //     this.loading = true;
    //     // await this.getRegionsFromServer();
    //     this.loading = false;
    //   } catch (e) {
    //     this.loading = false;
    //   }
    // },
    // async blockRegion(row){
    //   this.blocking.value = true;
    //   this.blocking.id = row.id;
    //   if (row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === 2) && row.stageDataBlocks.find(el => el.stageId === 2)?.block === true)
    //   await UserController.unBlock('region', 2, row.id)
    //       .finally(() => {
    //         this.blocking.value = false;
    //         this.blocking.id = null;
    //       });
    //   else
    //     await UserController.setBlock('region', 2, row.id)
    //         .finally(() => {
    //           this.blocking.value = false;
    //           this.blocking.id = null;
    //         });
    // },
    authAdOrg(row) {
      this.initFakeUser({
        role: 'ORGANIZATION_ROLE',
        id: row.id,
        name: row?.name ?? ''
      });
      Promise.allSettled([
        this.getOrgByOwner(row.id),
        this.getAllAppealsFormsFive(),
        this.getContact(),
        this.loadingFiles(),
        this.loadingBlockInfo(),
        this.getAllOrganizationAppeals(),
      ])
          .then(() => this.$router.push('/'))
          .catch(e => console.error(e))

      // this.loadingBlockInfo();

    }
  },
}
</script>

<style scoped>

</style>